import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import FormRow from '../../../../../../components/FormRow';
import InputHandler from '../../../../../../components/InputHandler';
import { IFormContext, withFormContext } from '../../../../../../containers/FormContextHandler';
import { epilepsySyndromeOptionsWithHeaders } from '../../../../utils/definitions';

const SyndromeForm = ({ editing, formData }: IFormContext): React.JSX.Element => {
  return (
    <React.Fragment>
      <FormRow title="diagnosis.epilepsy.diagnosisDate">
        <InputHandler
          type="PartialDate"
          editing={!!editing}
          name="date"
          formData={formData}
          dateDefault="now"
          isNotCancellable={true}
        />
      </FormRow>
      <FormRow title="diagnosis.epilepsy.syndrome.syndrome">
        <InputHandler
          type="Radio"
          editing={!!editing}
          name="syndrome"
          formData={formData}
          options={epilepsySyndromeOptionsWithHeaders}
          optionFormatter={(s: string | number): React.JSX.Element => {
            if (typeof s === 'string' && s.substring(0, 6) === 'header')
              return <FormattedMessage id={`diagnosis.epilepsy.syndrome.headers.${s}`} />;
            return <FormattedMessage id={`diagnosis.epilepsy.syndrome.opts.${s}`} />;
          }}
          optionSpecificElements={[
            {
              otherKnownSyndrome: (
                <div style={{ marginLeft: '3rem' }}>
                  <InputHandler
                    type="TextField"
                    name="syndromeSpecification"
                    editing={!!editing}
                    formData={formData}
                    placeholder={'diagnosis.epilepsy.etiology.specification'}
                  />
                </div>
              ),
            },
          ]}
        />
      </FormRow>
      <FormRow title="diagnosis.epilepsy.orphaCode">
        <InputHandler
          type="NumberField"
          editing={!!editing}
          name="orphaCode"
          formData={formData}
          placeholder={'diagnosis.epilepsy.orphaCode'}
        />
      </FormRow>
    </React.Fragment>
  );
};

export default withFormContext(SyndromeForm);
